import { render } from "./Sidebar.vue?vue&type=template&id=93a468c4&scoped=true&ts=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=93a468c4&scoped=true&lang=less"
import "./Sidebar.vue?vue&type=style&index=1&id=93a468c4&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93a468c4"]])

export default __exports__